var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldLowTrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 39,
    viewBox: "0 0 29 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8846 6.06924C21.7108 6.06924 15.3127 0.346494 15.2493 0.289163C14.8241 -0.0963878 14.1759 -0.0963878 13.7507 0.289163C13.687 0.34694 7.30562 6.06924 1.11538 6.06924C0.499395 6.06924 0 6.56863 0 7.18462V20.7949C0 31.616 8.04832 35.94 14.1022 38.2511C14.2303 38.3 14.3651 38.3244 14.5 38.3244C14.6349 38.3244 14.7697 38.3 14.8978 38.2511C23.3862 35.0105 29 29.9557 29 20.7949V7.18462C29 6.56863 28.5006 6.06924 27.8846 6.06924Z",
    fill: "url(#paint0_linear_469_61680101)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_469_61680101",
    x1: 14.5,
    y1: 38.3062,
    x2: 14.5,
    y2: 0.234369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#FF8C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC09C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLowTrust);
export default __webpack_public_path__ + "static/media/ShieldLowTrust.dcae3bd4031e934938a56ce3918c2875.svg";
export { ForwardRef as ReactComponent };